import {
	animation,
	trigger,
	animate,
	transition,
	state,
	style,
	query,
	group,
	animateChild,
	stagger
} from '@angular/animations';

export const fadeIfAnimation = trigger('fadeIfAnimation', [
	transition(':enter', [
    style({ opacity: 0 }),
    animate('250ms ease-out', style({ opacity: 1 })),
  ]),
  transition(':leave', [
    animate('250ms ease-out', style({ opacity: 0 }))
  ])
]);

export const fadeInAnimation = trigger('fadeInAnimation', [
	transition(':enter', [
    style({ opacity: 0 }),
    animate('0.8s ease-out', style({ opacity: 1 })),
  ]),
  transition(':leave', [
    animate('0.8s ease-out', style({ opacity: 0 }))
  ])
]);

export const facetsAnimation = trigger('facetsAnimation', [
  transition(':enter', [
    style({ opacity: 0, height: '0px' }),
    animate('250ms ease-in-out', style({ opacity: 1, height: '*' }))
  ]),
  transition(':leave', [
    style({ opacity: 1, height: '*' }),
    animate('250ms ease-in-out', style({ opacity: 0, height: '0px' }))
  ]),
  transition(':enter, :leave', [
    query('@*', animateChild())
  ])
]);

export const ifHeightAnimation = trigger('ifHeightAnimation', [
  transition(':enter', [
    style({ opacity: 0, height: '0px' }),
    animate('250ms ease-in-out', style({ opacity: 1, height: '*' }))
  ]),
  transition(':leave', [
    style({ opacity: 1, height: '*' }),
    animate('250ms ease-in-out', style({ opacity: 0, height: '0px' }))
  ]),
  transition(':enter, :leave', [
    query('@*', animateChild())
  ])
]);
